<div *ngIf="loadingState" class="cssload-container">
  <div>
    <img
      src="/assets/images/logos/loader-gif.svg"
      class="cssload-speeding-wheel"
      alt="loader"
    />
  </div>
</div>
